import { render, staticRenderFns } from "./body-date.vue?vue&type=template&id=02a1e776"
import script from "./body-date.vue?vue&type=script&lang=js"
export * from "./body-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports